module.exports = __webpack_public_path__ + "img/culture_img1.c85afa7e.png";